module.exports = __webpack_public_path__ + "static/media/10cent.6f45de9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/10cent.png
// module id = 923
// module chunks = 0